<template>
  <el-dialog
      :close-on-click-modal="false"
      title="修改"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
          @sub="sub"
          :noSubBtn="true"
          ref="customForm"
          :formData="formData"
          labelWidth="140px"
      >
        <!-- 订单号 -->
        <span slot="orderId" slot-scope="prop">{{prop.form.orderId}}</span>
        <!-- 订单号 end -->
        <!--司机类型-->
        <!-- <span slot="driverType" slot-scope="prop">{{prop.form.driverType === 1 ? '主驾' : '副驾'}}</span>-->
        <!--司机类型 end-->
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  driverSalaryDetailEdit,
  updateSalaryByUser,
} from 'api/getPay';
import {mapState} from 'vuex';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '订单号',
            value: 'orderId',
            slot: true,
          },
          {
            label: '公里数',
            value: 'mieageNumber',
            type: 'input',
            hide: true,
          },
          {
            label: '本趟总服务费',
            value: 'freightOfOrder',
            type: 'input',
            hide: true,
            onBlur: () => this.setRelationDriver(),
          },
          {
            label: '司机角色',
            value: 'driverType',
            type: 'input',
            hide: true,
            slot: true,
          },
          { label: '本趟工资',
            value: 'tripSalaryFee',
            type: 'input',
            hide: true,
          },
          {
            label: '节油奖',
            value: 'saveOilBonus',
            type: 'input',
            hide: true,
          },
          {
            label: '司机基本工资',
            value: 'orderBaseSalary',
            type: 'input',
            hide: true,
            onBlur: () => this.setFreightOfOrder(),
          },
          {
            label: '订单补贴',
            value: 'orderSubsidy',
            type: 'input',
            hide: true,
          },
          {
            label: '备注',
            value: 'subsidyRemark',
            type: 'input',
            hide: true,
          },
          {
            label: '订单扣款',
            value: 'orderDeduction',
            type: 'input',
            hide: true,
          },
          {
            label: '订单扣款备注',
            value: 'deductionRemark',
            type: 'input',
            hide: true,
          },
        ],
        rules: { // 表单验证规则
          mieageNumber: [ // 公里数
            { required: true, message: '请输入公里数', trigger: 'blur' },
          ],
          tripSalaryFee: [ // 本趟工资
            { required: true, message: '请输入本趟工资', trigger: 'blur' },
          ],
          saveOilBonus: [ // 节油奖
            { required: true, message: '请输入节油奖', trigger: 'blur' },
          ],
          orderBaseSalary: [ // 司机基本工资
            { required: true, message: '请输入司机基本工资', trigger: 'blur' },
            {
              validator: this.checkOrderBaseSalary, trigger: 'blur',
            },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    checkOrderBaseSalary (rule, value, call) {
      if (String(value).replace(/[^\d]/g, '')) {
        if (value && value < 0) {
          if (this.userInfo.staffTFInfo.tenantId === 2483 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538) {
            call('司机基本服务费不可为负数');
          } else {
            call('司机基本工资不可为负数');
          }
        } else {
          call();
        }
      } else {
        call('只可输入数字');
      }
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      item.orderDeduction = item.orderDeductionDouble;
      if (item.paymentWay !== 4) {
        this.$nextTick(() => {
          this.$refs.customForm.reset();
          this.originData = item;
          this.freightOfOrder = this.originData.freightOfOrderDouble;
          item.mieageNumber = item.mieageNumberStr;
          item.tripSalaryFee = item.thisSalaryDouble;
          item.saveOilBonus = item.oilSavingAwardsDouble;
          this.$refs.customForm.setVal(item);
        });
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: false,
          names: ['mieageNumber', 'tripSalaryFee', 'saveOilBonus'],
        });
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: true,
          names: ['orderBaseSalary', 'orderSubsidy', 'subsidyRemark'],
        });
      } else {
        this.$nextTick(() => {
          this.$refs.customForm.reset();
          this.originData = item;
          item.orderBaseSalary = item.orderBaseSalaryDouble;
          item.orderSubsidy = item.orderSubsidyDouble;
          this.freightOfOrder = this.originData.freightOfOrderDouble;
          this.$refs.customForm.setVal(item);
        });
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: true,
          names: ['mieageNumber', 'tripSalaryFee', 'saveOilBonus'],
        });
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: false,
          names: ['orderBaseSalary', 'orderSubsidy', 'subsidyRemark'],
        });
      }

      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: false,
        names: ['orderDeduction', 'deductionRemark'],
      });

      this.formChange(item);
    },

    setFreightOfOrder () {// “司机基本工资”联动"本趟运费""实发比例"
      this.freightOfOrder = this.originData.actualProportion === 0 ? 0 : (this.$refs.customForm.getVal('orderBaseSalary') / this.originData.actualProportionStr * 100).toFixed(2);
    },
    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const deductionForm = {
        orderDeduction: form.orderDeduction,
        deductionRemark: form.deductionRemark,
      };
      if (this.originData.paymentWay !== 4) {
        form = {
          orderId: form.orderId,
          saveOilBonus: form.saveOilBonus,
          tripSalaryFee: form.tripSalaryFee,
          mieageNumber: form.mieageNumber,
          ...deductionForm,
        };
      } else {
        form = {
          orderId: form.orderId,
          orderBaseSalary: form.orderBaseSalary,
          orderSubsidy: form.orderSubsidy,
          subsidyRemark: form.subsidyRemark,
          ...deductionForm,
        };
      }
      const res = await driverSalaryDetailEdit({
        salaryId: this.$route.query.id,
        ...form,
        freightOfOrder: this.freightOfOrder,
        actualProportion: this.originData.actualProportionStr,
      });
      this.subLoading = false;
      if (!res.failed) {

        const updateRes = await updateSalaryByUser({
          userId: this.originData.carDriverId,
          settleMonth: this.formatDate(this.originData.dependTime, 3),
          tenantId: this.userInfo.staffTFInfo.tenantId,
        });
        if (!updateRes.failed) {
          this.dialogFormVisible = false; // 关闭弹窗
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.$emit('sub');
        }


      }
    },
    formChange () {
      if (this.userInfo.staffTFInfo.tenantId === 2521 || this.userInfo.staffTFInfo.tenantId === 2525) { // 2.0.0绿丝特
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: true,
          names: ['orderSubsidy', 'subsidyRemark'],
        });
      }
    },
  },
  created () {
    if (this.userInfo.staffTFInfo.tenantId === 2483 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538) {
      this.formData.form.map((item) => {
        if (item.label === '司机基本工资') {
          item.label = '司机基本服务费';
        }
        if (item.label === '本趟工资') {
          item.label = '本趟服务费';
        }
      });
      Object.keys(this.formData.rules).forEach((key) => {
        if (key === 'orderBaseSalary') {
          this.formData.rules[key][0].message = '请输入司机基本服务费';
        }
      });
    }
  },
};
</script>

<style>
</style>
